/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect, type PropsWithChildren, type ReactNode } from 'react';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useCustomThemeData } from '../custom-theme-context/index.tsx';

/**
 *
 * Component that fires an analytics event when custom theme data is available.
 * Wraps children components to ensure the context is available.
 * behind the feature flag `jira_nav4_custom_theme_metrics`.
 *
 * @param children - The child components to be wrapped.
 * @returns
 */
export function CustomThemeAnalytics({ children }: PropsWithChildren): ReactNode {
	const customThemeData = useCustomThemeData();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		// Fire analytics only when all setters have finished
		const isThemeEvaluated = [
			'hasCustomBGColor',
			'hasCustomHighlightColor',
			'hasCustomLogo',
			'hasCustomSiteTitle',
		].every((key) => key in customThemeData);

		if (isThemeEvaluated) {
			createAnalyticsEvent({
				action: 'viewed',
				actionSubject: 'topNav',
				actionSubjectId: 'customTheme',
				attributes: {
					...customThemeData,
				},
				eventType: 'ui',
			}).fire('navigation');
		}
	}, [customThemeData, createAnalyticsEvent]);

	return children;
}
